import React from 'react'
import { Container, Col } from 'reactstrap'
import {
  Section,
  Paragraph,
  H4,
  H6,
  RowCentered,
  TextContainer
} from '../../GlobalStyles'
import theme from '../../theme'

export const BenefitsSection = () => {
  return (
    <Section>
      <Container>
        <RowCentered>
          <TextContainer as={Col} xs='12' md='9'>
            <H4 color={theme.colors.navy}>Why ADM Is Right For You</H4>
            <H6 color={theme.colors.darkGold}>
              We are bringing the American Development Model to Golf
            </H6>
            <Paragraph color={theme.colors.blueGray}>
              Let's maximize each athlete’s potential; create well-rounded
              athletes and develop principles that create life-long golfers and
              athletes for generations. Now is the time to start your journey
              with PGA.Coach education, and gain access to all of the tools you
              need to create passionate students and life-long golfers.
            </Paragraph>
          </TextContainer>
        </RowCentered>
      </Container>
    </Section>
  )
}

export default BenefitsSection
